import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../app/providers';
import { href, Link } from '../../app/router';
import { linkClass } from '../../ui';
import { shareKeys } from '../sharing/keys';
import { Section } from './cards';
import { INBOX_NAME } from './queries';

export function useSharedWithMe() {
  const api = useApi();
  return useQuery({ queryKey: shareKeys.shared, queryFn: () => api.sharedWithMe(), enabled: api.capabilities.sharing });
}

/** Projects and boards granted from outside the user's organizations (externals land here). */
export function SharedPage({ orgless = false }: { orgless?: boolean }) {
  const { t } = useTranslation();
  const api = useApi();
  const shared = useSharedWithMe();
  const items = shared.data ?? (api.capabilities.sharing ? undefined : []);
  return (
    <>
      <h1 className="font-display text-display-md font-normal tracking-display text-fg">{t('dashboard.shared')}</h1>
      <Section title={t('dashboard.boards')}>
        {items?.length === 0 && <p className="font-sans text-sm text-fg-muted">{t(orgless ? 'dashboard.noOrg' : 'dashboard.sharedEmpty')}</p>}
        <ul className="flex flex-col gap-2">
          {items?.map((s) => (
            <li key={`${s.kind}-${s.id}`} className="flex flex-wrap items-baseline gap-2 rounded-md border border-border px-3 py-2">
              <Link to={s.kind === 'board' ? href('board', { boardId: s.id }) : href('project', { projectId: s.id })} className={linkClass}>
                {s.title}
              </Link>
              <span className="font-mono text-xs text-fg-muted">
                {[s.orgName, s.projectName === INBOX_NAME ? t('dashboard.noProject') : s.projectName, t(`sharing.roles.${s.role}`)].filter(Boolean).join(' · ')}
              </span>
            </li>
          ))}
        </ul>
      </Section>
    </>
  );
}
